import styled from "styled-components";

export const HistoricalPerformanceChartContainer = styled.div`
  position: relative;
  height: 100%;

  .investment-value {
    .total {
      .amount {
        margin-bottom: 0px;
        color: var(--colors-text-text-primary-900, #181d27);
        font-family: var(--Font-family-font-family-display, Aeonik);
        font-size: var(--Font-size-display-xs, 25px);
        font-style: normal;
        font-weight: 600;
        line-height: var(--Line-height-display-xs, 32px);

        .metric-value-decimal {
          font-size: 16px;
          line-height: 1;
          vertical-align: super;
          padding-left: 2px;
        }
      }

      .extra-info {
        line-height: 1;
        margin-bottom: 0px;
        font-size: ${({ theme }) => theme.constants.FONT_SIZE_15};
        font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
        display: flex;
        align-items: center;
        gap: 3px;

        .percentage {
          border-radius: 25px;
          padding: 10px;
          height: 27px;
          font-size: 14px;
          font-weight: 500;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 3px;

          &.gain {
            background-color: ${({ theme }) => theme.global.bg.profit};
            color: ${({ theme }) => theme.constants.COLOR_GREEN};
          }

          &.loss {
            background-color: ${({ theme }) => theme.global.bg.loss};
            color: ${({ theme }) => theme.constants.COLOR_RED};
          }
        }

        .benchmark-wrapper {
          display: flex;
          width: 100%;
          flex-wrap: no-wrap;
          align-items: center;
          color: ${({ theme }) => theme.tab.color.quinary};
          font-size: 14px;

          .benchmark {
            border-radius: 25px;
            padding: 10px;
            height: 27px;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 3px;
            background-color: ${({ theme }) => theme.tab.bg.quaternary};
            color: ${({ theme }) => theme.tab.color.quinary};
          }
        }
      }
    }

    .date {
      font-size: 12px;
      margin-left: 5px;
      color: ${({ theme }) => theme.tab.color.quinary};
    }
  }

  @media (max-width: 820px) {
    .investment-value {
      .total {
        flex-direction: column;
        font-size: 24px;
        line-height: 1;
      }

      .gain {
        font-size: 12px;
      }
    }

    .recharts-surface {
      margin-top: 1rem;
    }

    .h-performance-filter {
      margin: 1rem 0rem;
    }
  }
`;

export const LegendContainer = styled.ul`
  background: ${({ theme }) => theme.button.bg.secondary};
  border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_8};
  padding: 10px 0;

  li {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .line {
    border-radius: 10px;
    width: 15px;
    height: 2px;
    display: inline-block;
    margin-right: 6px;
  }

  .name {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    opacity: ${({ theme }) => theme.chart.legend.opacity};
    font-weight: 500;
    font-size: 10px;
  }

  .value {
    font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_600};
    font-size: 14px;
  }

  .date {
    font-size: 12px;
    margin-left: 5px;
  }

  @media (max-width: 820px) {
    .gain {
      font-size: 12px;
    }
  }
`;

export const HeaderComponent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
  margin-bottom: 12px;

  .current-balance {
    margin-bottom: 0px;
    color: var(--colors-text-text-quaternary-500, #717680);
    font-size: var(--Font-size-text-xs, 12px);
    font-style: normal;
    font-weight: 400;
    line-height: var(--Line-height-text-xs, 18px);
  }

  @media (max-width: 820px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
